// Envuelve la consulta de rol distinguiendo si CONTESTÓ de si la respuesta
// vino vacía.
//
// FUENTE DE VERDAD. Se COPIA a cada app con scripts/sync-ui.sh (junto al
// resto de shared/vls-ui/). Si se edita, correr el script para propagar; NO
// editar las copias de cada app.
//
// Hoy los AuthContext de Gerencia y Taller mapean tanto "la consulta no
// contestó" (caída de red) como "contestó que no hay fila" (la persona no
// es miembro) al mismo role = null, y el gate no puede distinguirlos: una
// caída de red de medio segundo termina en la misma pantalla de sin-acceso,
// a pantalla completa y sin reintento, que le mostraría a alguien sin
// permisos reales. Lo que separa los casos es si la consulta CONTESTÓ, no
// si la respuesta vino vacía. Esa frase es todo el diseño. Detalle en
// docs/superpowers/specs/2026-09-07-consulta-de-rol-fallida-design.md.
//
// estado             cuándo                                      rol
// 'ok'               la consulta contestó y hay rol               el rol
// 'sin-membresia'    la consulta contestó y no hay fila           null
// 'error'            la consulta falló, agotados los reintentos   null
//
// consulta: función sin argumentos que devuelve una promesa con la forma de
// supabase-js, { data, error }. Se recibe como argumento porque cada app
// pregunta distinto (una llama un RPC, otra consulta una tabla); este
// ayudante no sabe cuál ni le importa.
//
// Cuenta como fallo tanto un error en la respuesta como una excepción
// lanzada. Un data nulo NO es fallo: es sin-membresia.
//
// Va aparte del componente a propósito: es JS plano, sin React ni JSX, así
// que se prueba con `node --test` sin bundler ni jsdom.

const esperar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const resolverRol = async (consulta, opciones = {}) => {
  const { reintentos = 1, esperaMs = 1000 } = opciones;
  const intentosTotales = reintentos + 1;

  for (let intento = 0; intento < intentosTotales; intento += 1) {
    let resultado = null;

    try {
      resultado = await consulta();
    } catch {
      resultado = null; // una excepción cuenta como fallo, igual que un error en la respuesta
    }

    if (resultado && !resultado.error) {
      const rol = resultado.data ?? null;
      return rol === null ? { estado: 'sin-membresia', rol: null } : { estado: 'ok', rol };
    }

    const quedanIntentos = intento < intentosTotales - 1;
    if (quedanIntentos) {
      await esperar(esperaMs);
    }
  }

  return { estado: 'error', rol: null };
};
